interface LeaderboardSession
{
  access_token: string;
  userId: number;
  game_player_id: string;
}

let _session: LeaderboardSession | null = null;

export const LeaderboardAuthSession = {
  set( session: LeaderboardSession ): void
  {
    _session = session;
  },

  get(): LeaderboardSession | null
  {
    return _session;
  },

  getToken(): string | null
  {
    return _session?.access_token ?? null;
  },

  getUserId(): number | null
  {
    return _session?.userId ?? null;
  },

  clear(): void
  {
    _session = null;
  },
};
